import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1000To1099Service {

  constructor() { }
}
